import { apiInstances } from '../../../../libs';

const { post } = apiInstances.orderInstance;

export default async function confirmReturnToPickupFromConsumer({
  id_order,
  ...payload
}) {
  return await post(
    `/clouders/orders/${id_order}/return-to-pickup-from-consumer`,
    payload
  );
}
